'use client';

import { defaultLocale } from "@/i18n/config";

const COOKIE_NAME = "NEXT_LOCALE";

/**
 * Client-side locale management
 */

export function getUserLocaleClient() {
  if (typeof document === 'undefined') return defaultLocale;
  
  // Get from cookie
  const cookies = document.cookie.split(';');
  const localeCookie = cookies.find(cookie => cookie.trim().startsWith(`${COOKIE_NAME}=`));
  
  if (localeCookie) {
    const locale = localeCookie.split('=')[1];
    return locale;
  }
  
  return defaultLocale;
}

export function setUserLocaleClient(locale) {
  if (typeof document === 'undefined') return;
  
  // Set cookie
  document.cookie = `${COOKIE_NAME}=${locale}; path=/; max-age=31536000`; // 1 year
  
  // Also store in localStorage for immediate access
  localStorage.setItem('userLocale', locale);
  localStorage.setItem('hotple-last-selected-language', locale);
}

export function getBrowserLanguageClient() {
  if (typeof navigator === 'undefined') return 'en';
  
  const browserLang = navigator.language || navigator.languages?.[0] || 'en';
  const langCode = browserLang.split('-')[0];
  
  return langCode;
}

// Simple status check function for debugging
if (typeof window !== 'undefined') {
  window.checkLangStatus = () => {
    const current = getUserLocaleClient();
    const browser = getBrowserLanguageClient();
    const manual = localStorage.getItem('isManuallySetLocale') === 'true';
    const manualChoice = localStorage.getItem('manualLanguageChoice');
    const autoDetected = localStorage.getItem('hasAutoDetectedLanguage') === 'true';
    
    // console.log(`[LangStatus] Current: ${current}, Browser: ${browser}, Manual: ${manual}, Choice: ${manualChoice}, AutoDetected: ${autoDetected}`);
    return { current, browser, manual, manualChoice, autoDetected };
  };

  // Force browser language detection
  window.forceBrowserLang = () => {
    localStorage.removeItem('isManuallySetLocale');
    localStorage.removeItem('hasAutoDetectedLanguage');
    localStorage.removeItem('detectionRunThisSession');
    localStorage.removeItem('manualLanguageChoice');
    
    // Set to current browser language immediately
    const browserLang = getBrowserLanguageClient();
    setUserLocaleClient(browserLang);
    
    // Determine correct mode based on browser language
    // const { hasManualTranslations } = require('@/i18n/config');
    // const correctMode = hasManualTranslations(browserLang) ? 'manual' : 'browser';
    
    // Trigger language change event with system translation mode
    window.dispatchEvent(new CustomEvent('languageChanged', { detail: { language: browserLang, mode: 'browser' } }));
  };
}